<div class="auth-page">
  <div class="auth-card">
    <ng-container [ngSwitch]="state">

      <!-- INVALID OR MISSING LINK -->
      <ng-container *ngSwitchCase="'invalidLink'">
        <h1 class="auth-title">Reset link not valid</h1>
        <p class="auth-confirmation">
          This password reset link is missing or incomplete. It may have been copied without all of its parts, or it may have expired.
        </p>
        <button class="primary-btn" type="button" (click)="goToForgotPassword()">Request a new reset link</button>
        <p class="auth-footer">
          <a class="auth-link" (click)="goToSignIn()">Back to sign in</a>
        </p>
      </ng-container>

      <!-- RESET FORM -->
      <ng-container *ngSwitchCase="'form'">
        <h1 class="auth-title">Choose a new password</h1>
        <p class="auth-intro">
          Resetting password for <strong>{{ email }}</strong>.
        </p>

        <ng-container *ngIf="!loading; else loadingPanel">
          <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <div class="field-group">
              <label class="field-label">New password</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput required name="newPassword" type="password" autocomplete="new-password"
                       formControlName="newPassword" />
                <mat-error *ngIf="form.controls['newPassword'].hasError('required')">
                  Password is <strong>required</strong>
                </mat-error>
                <mat-error *ngIf="!form.controls['newPassword'].hasError('required') && form.controls['newPassword'].hasError('minlength')">
                  At least 8 characters
                </mat-error>
              </mat-form-field>
            </div>

            <div class="field-group">
              <label class="field-label">Confirm new password</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput required name="confirmPassword" type="password" autocomplete="new-password"
                       formControlName="confirmPassword" />
                <mat-error *ngIf="form.controls['confirmPassword'].hasError('required')">
                  Please re-enter the password
                </mat-error>
              </mat-form-field>
              <p class="field-helper" *ngIf="form.hasError('passwordMismatch') && form.controls['confirmPassword'].touched">
                Passwords do not match
              </p>
            </div>

            <p class="auth-error" *ngIf="errorMessage">{{ errorMessage }}</p>

            <button class="primary-btn" type="submit">Update password</button>
          </form>

          <p class="auth-footer">
            <a class="auth-link" (click)="goToForgotPassword()">Request a new reset link</a>
          </p>
        </ng-container>
      </ng-container>

      <!-- SUCCESS -->
      <ng-container *ngSwitchCase="'success'">
        <h1 class="auth-title">Password updated</h1>
        <p class="auth-confirmation">
          Your password has been changed. You can now sign in with the new one.
        </p>
        <button class="primary-btn" type="button" (click)="goToSignIn()">Sign in</button>
      </ng-container>

    </ng-container>

    <ng-template #loadingPanel>
      <div class="loading-container">
        <mat-progress-spinner class="loading-spinner" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    </ng-template>
  </div>
</div>
